import { getFmcAndFleetId } from "../actions/sagas/reportingSaga"

export function agGridColumnSubsciptionDefs(
  defaultCellRenderer,
  viewPaymentMethodRenderer,
  t,
  subscriptionActivities
) {
  const widths = {
    verySmall: 125,
    small: 150,
    medium: 175,
    large: 200,
    veryLarge: 225
  }
  var fields = [
    ...(getFmcAndFleetId().isFMC
      ? [
          {
            headerName: t("services:fleetName"),
            field: "fleet_name",
            cellRendererFramework: defaultCellRenderer,
            flex: 1
          }
        ]
      : []),
    {
      headerName: t("services:subscriptions"),
      field: "subscription",
      cellRendererFramework: defaultCellRenderer,
      flex: 1
    },
    {
      headerName: t("services:subscriptionDate"),
      field: "subscription_date",
      cellRendererFramework: defaultCellRenderer,
      flex: 1
    },
    {
      headerName: t("services:methodOfPayment"),
      field: "method_of_payment",
      cellRendererFramework: viewPaymentMethodRenderer,
      flex: 1
    },
    {
      headerName: t("services:numberOfVehicles"),
      field: "number_of_vehicles",
      cellRendererFramework: defaultCellRenderer,
      flex: 1
    },
    {
      headerName: t("services:amount"),
      field: "amount",
      cellRendererFramework: defaultCellRenderer,
      flex: 1
    }
  ]

  return fields
}

export function agGridSubscriptionRowData(subscriptionActivities, language) {
  return subscriptionActivities.map((subscriptionActivity) => {
    return {
      fleet_name: subscriptionActivity.fleet_name,
      subscription: subscriptionActivity.number_of_vehicles || 0,
      subscription_date: subscriptionActivity.subscription_date,
      method_of_payment: subscriptionActivity.id,
      number_of_vehicles: subscriptionActivity.number_of_vehicles || 0,
      amount: subscriptionActivity.amount || 0.0
    }
  })
}

export const NA = "N/A"
